import { useDispatch } from 'react-redux'
import { actions, initialState } from '../../../TransfersState'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import * as S from './BadgeInput.styles'
import { useEffect } from 'react'

interface FormData {
  badge: string;
}

const BadgeInput = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const {
    register,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>()

  useEffect(() => {
    dispatch(actions.setProperty({
      property: 'receiveUser',
      value: initialState.receiveUser,
    }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onBadgeSubmit = (formData: FormData) => {
    dispatch(
      actions.receiveValidateBadge({
        badge: formData.badge,
        history,
        onError: (message: string) => setError('badge', { message }),
      }),
    )
  }

  return (
    <S.Container>
      <S.Form onSubmit={handleSubmit(onBadgeSubmit)}>
        <S.CustomFieldMui
          inputProps={{
            ...register('badge', { required: 'Campo obrigatório' }),
            'data-testid': 'input-badge-test-id',
          }}
          error={!!errors.badge}
          helperText={errors.badge?.message}
          label='replacementForm.badgelabel'
          name='badge'
          testId='input-badge-test-id'
          type='password'
          size='medium'
          fullWidth
          autoComplete='off'
          autoFocus
        />
      </S.Form>
    </S.Container>
  )
}

export default BadgeInput
